import dayjs, { Dayjs } from "dayjs";
import { CRAComplianceData, CRAState } from "types/craCompliance";

const CRA_STATUS_DEFAULTS: Record<string, string> = {
  exploitStatus: "Unknown",
  notificationStatus: "Not Required",
  userDisclosureStatus: "Not Required",
};

export function getCRADefaultStatus(key: string): string {
  return CRA_STATUS_DEFAULTS[key] ?? "";
}

export const EXPLOIT_STATUS_OPTIONS = [
  { label: "Unknown", value: "Unknown" },
  { label: "No Exploit", value: "No Exploit" },
  { label: "Proof-of-concept", value: "Proof-of-concept" },
  { label: "Exploit Available", value: "Exploit Available" },
  { label: "Known Exploited", value: "Known Exploited" },
  { label: "Exploitable", value: "Exploitable" },
  { label: "Actively Exploited", value: "Actively Exploited" },
];

export const NOTIFICATION_STATUS_OPTIONS = [
  { label: "Not Required", value: "Not Required" },
  { label: "Pending Review", value: "Pending Review" },
  { label: "Pending Notification", value: "Pending Notification" },
  { label: "Early Warning Released", value: "Early Warning Released" },
];

export const USER_DISCLOSURE_STATUS_OPTIONS = [
  { label: "Not Required", value: "Not Required" },
  { label: "Pending", value: "Pending" },
  { label: "Delayed", value: "Delayed" },
  { label: "Notified", value: "Notified" },
];

export const DEFAULT_CRA_STATE: CRAState = {
  exploitStatus: getCRADefaultStatus("exploitStatus"),
  notificationStatus: getCRADefaultStatus("notificationStatus"),
  userDisclosureStatus: getCRADefaultStatus("userDisclosureStatus"),
  earlyWarningDue: null,
  notificationDue: null,
  finalReportDue: null,
  userDisclosureDue: null,
  remediationEvidence: "",
};

export function craDataToState(craData: CRAComplianceData): CRAState {
  return {
    exploitStatus: craData.exploitStatus,
    notificationStatus: craData.notificationStatus,
    userDisclosureStatus: craData.userDisclosureStatus,
    earlyWarningDue: epochToDayjs(craData.earlyWarningDue),
    notificationDue: epochToDayjs(craData.notificationDue),
    finalReportDue: epochToDayjs(craData.finalReportDue),
    userDisclosureDue: epochToDayjs(craData.userDisclosureDue),
    remediationEvidence: craData.remediationEvidence ?? "",
  };
}

export function craStateToApiData(state: CRAState): CRAComplianceData {
  return {
    exploitStatus: state.exploitStatus,
    notificationStatus: state.notificationStatus,
    userDisclosureStatus: state.userDisclosureStatus,
    earlyWarningDue: state.earlyWarningDue?.valueOf() ?? null,
    notificationDue: state.notificationDue?.valueOf() ?? null,
    finalReportDue: state.finalReportDue?.valueOf() ?? null,
    userDisclosureDue: state.userDisclosureDue?.valueOf() ?? null,
    remediationEvidence: state.remediationEvidence || null,
  };
}

export function epochToDayjs(epoch: number | null | undefined): Dayjs | null {
  if (!epoch) return null;
  return dayjs(epoch);
}
